var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect, useRef, useCallback } from "react";
import { ChromePicker } from "react-color";
import Input from "../Input/Input";
import styled from "styled-components";
import { usePopper } from "react-popper";
import ClickAwayListener from "../ClickAwayListener/ClickAwayListener";
var StyledChromePicker = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n"], ["\n  display: ", ";\n"])), function (props) { return (props.$open ? "block" : "none"); });
var ColorPicker = function (_a) {
    var label = _a.label, _b = _a.color, color = _b === void 0 ? "#ee9b00" : _b, open = _a.open, size = _a.size, width = _a.width, onChange = _a.onChange;
    var _c = useState(open !== null && open !== void 0 ? open : false), isOpen = _c[0], setIsOpen = _c[1];
    var _d = useState(color), innerColor = _d[0], setInnerColor = _d[1];
    var anchorElement = useRef(null);
    var popperElement = useRef(null);
    React.useEffect(function () {
        setInnerColor(color);
    }, [color]);
    useEffect(function () {
        setIsOpen(open !== null && open !== void 0 ? open : false);
    }, [open]);
    var _e = usePopper(anchorElement.current, popperElement.current, {
        placement: "bottom-start",
        modifiers: [
            {
                name: "offset",
                options: {
                    offset: [0, 2.5],
                },
            },
        ],
    }), styles = _e.styles, attributes = _e.attributes, update = _e.update;
    var _onChange = function (color) {
        setInnerColor(color.hex);
        onChange && onChange(color.hex);
    };
    var _onInputChange = function (e) {
        setInnerColor(e.target.value);
        onChange && onChange(e.target.value);
    };
    var _onInputClick = function () {
        setIsOpen(!isOpen);
    };
    var handleClickAway = useCallback(function () {
        setIsOpen(false);
    }, []);
    useEffect(function () {
        if (isOpen && update) {
            update();
        }
    }, [isOpen, update]);
    return (_jsxs(ClickAwayListener, __assign({ onClickAway: handleClickAway }, { children: [_jsx(Input, { width: width, size: size, label: label, ref: anchorElement, value: innerColor, onChange: _onInputChange, onClick: _onInputClick, leadingIcon: _jsx("div", { onClick: function () { return setIsOpen(!isOpen); }, style: {
                        width: "20px",
                        height: "20px",
                        backgroundColor: innerColor,
                        borderRadius: "4px",
                    } }) }), _jsx(StyledChromePicker, __assign({ ref: popperElement, "$open": isOpen, style: __assign({}, styles.popper) }, attributes.popper, { children: _jsx(ChromePicker, { disableAlpha: true, color: innerColor, onChange: _onChange }) }))] })));
};
export default ColorPicker;
var templateObject_1;
